import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { verifySignupOtp, resendSignupOtp } from '../api/signup'; // 👈 Add resendSignupOtp
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import { seoDefaults } from "../utils/seoDefaults";
import SEO from "../api/seo";

const OtpVerify = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { login } = useAuth();
  const email = state?.email;
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [secondsLeft, setSecondsLeft] = useState(180); // 3 minutes
  const [resendLoading, setResendLoading] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (s) => {
    const m = Math.floor(s / 60).toString().padStart(2, '0');
    const sec = (s % 60).toString().padStart(2, '0');
    return `${m}:${sec}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await verifySignupOtp(email, otp);
      login(res.token, res.user);
      toast.success("OTP verified successfully!");
      navigate('/user-profile'); 
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid OTP');
    }
  };

  const handleResend = async () => {
    if (!email || secondsLeft > 0) return;
    try {
      setResendLoading(true);
      await resendSignupOtp(email);
      toast.success("New OTP sent to email");
      setSecondsLeft(180);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to resend OTP");
    } finally {
      setResendLoading(false);
    }
  };

  return (
        <>
     <SEO {...seoDefaults.forgotPassword} />
    <div className="min-h-screen flex items-center justify-center bg-gray-950 text-white relative overflow-hidden">
      <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-purple-900/15 rounded-full filter blur-3xl animate-pulse"></div>
      <div className="absolute top-1/2 right-1/4 w-96 h-96 bg-cyan-900/20 rounded-full filter blur-3xl animate-pulse"></div>

      <div className="relative z-10 w-full max-w-md p-8 rounded-2xl bg-gradient-to-br from-gray-900 to-gray-800 shadow-lg border border-gray-700/60">
        <h2 className="text-3xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-cyan-500">
          Enter OTP
        </h2>

        <form onSubmit={handleSubmit} className="space-y-5">
          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter the OTP"
            className="w-full p-3 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500"
            required
          />
          {error && <p className="text-sm text-red-400">{error}</p>}
          <button
            type="submit"
            className="w-full py-3 rounded-lg bg-gradient-to-r from-purple-600 to-cyan-500 text-white font-semibold tracking-wide hover:shadow-lg hover:shadow-purple-500/30 transition-all"
          >
            VERIFY OTP
          </button>
        </form>

        <div className="text-center mt-4 text-sm text-gray-300">
          <p>
            {secondsLeft > 0 ? (
              <>Resend available in <span className="text-cyan-400 font-semibold">{formatTime(secondsLeft)}</span></>
            ) : (
              <button
                onClick={handleResend}
                className="text-cyan-400 font-semibold hover:underline disabled:opacity-50"
                disabled={resendLoading}
              >
                {resendLoading ? "Sending..." : "Resend OTP"}
              </button>
            )}
          </p>
        </div>
      </div>
    </div>
    </>
  );
};

export default OtpVerify;
